<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import Flash from "@shared/services/flashv2.js";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import { updateDefaultDistributor } from "@retailer/services/default_distributors";
  import type { Distributor } from "@shared/types/Distributor";

  export let distributor: Distributor;
  export let productTypeName: string;
  export let productTypeId: number;
  export let showModal: boolean;
  export let closeCallback: () => void = () => {};

  let submitting: boolean = false;

  const closeModal = () => {
    if (submitting) return;

    showModal = false;
    closeCallback();
  };

  const submit = async () => {
    submitting = true;
    await updateDefaultDistributor(productTypeId, distributor.id, successCallback, errorCallback);

    submitting = false;
    closeModal();
  };

  const successCallback = function (
    _productTypeId: number,
    _spiritsDefaultedDistributorId: number
  ) {
    Flash.now({
      type: "success",
      header: `${distributor.name} is now your default store for ${productTypeName}.`,
      message: `You can change this at anytime in <a href="/settings/accounts">My Distributors</a>.`,
      rawHtml: true,
      dismissible: true,
      keep: true,
    });
  };
  const errorCallback = function (_res) {
    Flash.now({
      type: "error",
      message:
        "Sorry - we had a problem setting your default distributor. If you contact support we would be happy to help you.",
    });
  };

</script>

<FizzStyles>
  <Modal bind:show={showModal} fizzModal={true} medium={true}>
    <div class="layout-header-footer">
      <header class="fizz-modal-header fizz-align-content-start">
        <h4 class="fizz-heading-4">
          Would you like to set {distributor.name} as your default store for {productTypeName}?
        </h4>
        <div class="fizz-modal-toggle fizz-modal-close" on:click={closeModal}>
          <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" />
        </div>
      </header>
      <footer class="fizz-modal-footer fizz-flex-row-8 fizz-justify-end">
        <button class="fizz-button fizz-modal-toggle" on:click={closeModal} disabled={submitting}>
          No, don't set
        </button>
        <button
          class="fizz-button-secondary fizz-modal-toggle"
          on:click={submit}
          disabled={submitting}
        >
          Yes, set
        </button>
      </footer>
    </div>
  </Modal>
</FizzStyles>
